module.exports = __webpack_public_path__ + "static/media/nyu-dentistry-building.085c92a6.jpg";